export default [
  {
    path: '/smelter/:id',
    name: 'smelter',
    component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Smelter/Smelter'),
    reverse: 'smelters-single',
    meta: { permission: 'api.view_smelter' }
  },
  {
    path: '/smelter/:id/edit',
    name: 'edit-smelter',
    component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Smelter/EditSmelter'),
    meta: { permission: 'api.change_smelter' }
  },
  {
    path: '/smelter-list',
    name: 'smelter-list',
    component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Smelter/SmelterList'),
    meta: { permission: 'api.view_smelter' }
  },
  {
    path: '/hedge/:id',
    name: 'hedge',
    component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Hedges/Hedge'),
    reverse: 'hedges-single',
    meta: { permission: 'api.view_hedge' }
  },
  {
    path: '/hedge-list',
    component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Hedges/HedgeParent'),
    children: [
      {
        path: '',
        name: 'hedge-list',
        component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Hedges/HedgeList'),
        meta: { permission: 'api.view_hedge' }
      },
      {
        path: '/create-hedge',
        name: 'create-hedge',
        component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Hedges/CreateHedge'),
        meta: { permission: 'api.add_hedge' }
      },
      {
        path: '/current-allocations',
        name: 'current-allocations',
        component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Hedges/Allocations/Allocations'),
        meta: { permission: 'api.view_allocation' }
      },
      // {
      //   path: '/check-in-allocations',
      //   name: 'check-in-allocations',
      //   component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Hedges/Allocations/AllocateCI'),
      //   meta: { permission: 'api.add_lot' }
      // },
      {
        path: '/current-purchases',
        name: 'current-purchases',
        component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Hedges/components/CurrentPurchases/CurrentPurchasesSection'),
        meta: { permission: 'api.view_current_purchase' }
      }
    ]
  },
  {
    path: '/reports/hedge/dump',
    name: 'hedge-dump-report',
    component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Reports/HedgeDumpReport'),
    meta: { permission: 'api.view_hedge_dump_report' }
  },
  // {
  //   path: '/reports/check-in-hedge/',
  //   name: 'check-in-hedge-report',
  //   component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Reports/CheckInHedgeReport'),
  //   meta: { permission: 'frontend.view_checkin_hedge_report' }
  // },
  {
    path: '/reports/hedge-report',
    name: 'hedge-report',
    component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Reports/HedgeReport'),
    meta: { permission: 'frontend.view_reports' }
  },
  // {
  //   path: '/reports/hedge-managers-report/',
  //   name: 'hedge-managers-report',
  //   component: () => import(/* webpackChunkName: "hedge-routes" */ '@/views/Reports/HedgeReport'),
  //   meta: { permission: 'frontend.view_reports' }
  // }
  {
    path: '/hedges/trade_confirmations',
    name: 'hedge-trade-confirmations',
    meta: {
      permission: 'api.view_hedgetradeconfirmation',
      redirect: '/site/hedges/trade_confirmations/'
    }
  }
]
